module.exports = __webpack_public_path__ + "static/img/03.384295e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/02/03.jpg
// module id = M1Wd
// module chunks = 0